import socket from '../socket';

let { socketEvent } = socket;

import enter from './enter';
import chat from './chat';
import tplMsg from './tpl-msg';
import gift from './gift';
import auth from './auth';
import broadcast from './broadcast';
import globalHandler from './global-handler';
import sendTip from '../../functions/gift/send-tip';

const init = ({
  initTplMsg = true,
  initEnter = true,
  initChat = true,
  initGift = true,
  initAuth = true,
  initBroadcast = false,
} = d) => {
  if (initEnter) {
    enter(socketEvent);
  }
  if (initChat) {
    chat(socketEvent);
  }
  if (initTplMsg) {
    tplMsg(socketEvent);
  }
  if (initGift) {
    gift(socketEvent);
  }
  if (initAuth) {
    auth(socketEvent);
  }
  if (initBroadcast) {
    broadcast(socketEvent);
  }

  globalHandler(socketEvent);

  sendTip.handleSocket(socketEvent);
};

export default {
  init,
};
